import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'gg-users-icon',
  templateUrl: './users-icon.component.html',
  styleUrl: './users-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UsersIconComponent {}
